import * as R from 'ramda';
import * as fns from 'date-fns';

const formatStr = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX";

export const parseStartDate = R.pipe((d) => {
  if (typeof d === 'string') {
    return fns.parseISO(d);
  } else {
    return d;
  }
}, fns.startOfDay, d => fns.format(d, formatStr));
export const parseEndDate = R.pipe((d) => {
  if (typeof d === 'string') {
    return fns.parseISO(d);
  } else {
    return d;
  }
}, fns.endOfDay, d => fns.format(d, formatStr));